<template>
  <div class="flex items-center justify-between px-[16px] py-2 gap-x-3 min-h-[40px]">
    <span class="w-full lg:max-w-[320px] text-sm text-[#44474A] font-semibold text-wrap text-truncate">
      {{ page.title }}
    </span>

    <span class="w-full text-sm text-[#44474A] text-wrap text-truncate">
      {{ pageLink }}
    </span>

    <div class="flex items-center gap-x-5">
      <span
        v-b-tooltip.hover
        :title="{'ACTIVE': 'Published', 'ACTIVE_LEGACY_CSS': 'Published (Legacy CSS)', 'DRAFT': 'Unpublished'}[pageStatus]"
        class="w-[10px] h-[10px] rounded-full"
        :class="[{'ACTIVE': 'bg-[#86c158]', 'ACTIVE_LEGACY_CSS': 'bg-[#fb923c]', 'DRAFT': 'bg-[#E2E5EC]'}[pageStatus]]"
      />
      
      <button
        v-b-tooltip.hover
        title="Preview Page"
        class="flex items-center gap-x-2 text-[#4F83E3] hover:opacity-80 transition p-0"
        :class="{'cursor-not-allowed opacity-50': page.page_status !== 'ACTIVE'}"
        :disabled="page.page_status !== 'ACTIVE'"
        @click="openPreview"
      >
        <svg
          width="19"
          height="19"
          viewBox="0 0 19 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="w-4 h-4"
        >
          <path
            d="M1.91593 10.0646C1.80812 9.89388 1.75421 9.80852 1.72403 9.67687C1.70136 9.57797 1.70136 9.42202 1.72403 9.32312C1.75421 9.19147 1.80812 9.10611 1.91593 8.9354C2.80688 7.52466 5.45886 3.95833 9.50032 3.95833C13.5418 3.95833 16.1938 7.52466 17.0847 8.9354C17.1925 9.10611 17.2464 9.19147 17.2766 9.32312C17.2993 9.42202 17.2993 9.57797 17.2766 9.67687C17.2464 9.80852 17.1925 9.89388 17.0847 10.0646C16.1938 11.4753 13.5418 15.0417 9.50032 15.0417C5.45886 15.0417 2.80688 11.4753 1.91593 10.0646Z"
            stroke="#4F83E3"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9.50032 11.875C10.812 11.875 11.8753 10.8117 11.8753 9.5C11.8753 8.18832 10.812 7.12499 9.50032 7.12499C8.18864 7.12499 7.12532 8.18832 7.12532 9.5C7.12532 10.8117 8.18864 11.875 9.50032 11.875Z"
            stroke="#4F83E3"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>

      <button
        v-b-tooltip.hover
        :title="copied ? 'Copied!' : 'Copy Page URL'"
        class="flex items-center gap-x-2 text-[#B3B3B3] hover:opacity-80 transition p-0"
        :class="{'cursor-not-allowed opacity-50': page.page_status !== 'ACTIVE'}"
        :disabled="page.page_status !== 'ACTIVE'"
        @click="copyPageLink"
      >
        <svg
          v-if="!copied"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-copy-icon lucide-copy w-4 h-4"
        >
          <rect
            width="14"
            height="14"
            x="8"
            y="8"
            rx="2"
            ry="2"
          />
          <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
        </svg>

        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-copy-check-icon lucide-copy-check w-4 h-4"
        >
          <path d="m12 15 2 2 4-4" />
          <rect
            width="14"
            height="14"
            x="8"
            y="8"
            rx="2"
            ry="2"
          />
          <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PagePreviewItem',
  props: {
    page: {
      type: Object,
      required: true
    },
    domain: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      opened: false,
      copied: false
    }
  },
  computed: {
    pageLink () {
      return `${this.domain}${this.page.slug && this.page.slug !== 'home' ? `/${this.page.slug}` : ''}`
    },
    pageStatus () {
      if (this.page.page_status === 'ACTIVE' && !this.page.css_file) return 'ACTIVE_LEGACY_CSS'
      else return this.page.page_status
    }
  },
  methods: {
    openPreview () {
      const url = this.page.page_status === 'ACTIVE' ? `https://${this.pageLink}` : `https://${this.pageLink}?preview=${this.page.hash}`
      window.open(url, '_blank')
    },
    copyPageLink () {
      this.copied = true
      navigator.clipboard.writeText(this.pageLink)

      setTimeout(() => {
        this.copied = false
      }, 800)
    }
  }
}
</script>
